"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ListGroup", {
    enumerable: true,
    get: function() {
        return ListGroup;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _FormGroupContext = require("../../contexts/FormGroupContext");
const _FormInputGroupContext = require("../Form/FormInputGroup/FormInputGroupContext");
const _Theme = require("../../contexts/Theme");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const ListGroup = /*#__PURE__*/ _react.default.forwardRef((param, ref)=>{
    let { children, maxHeight, noBorder, variant = "white", ...props } = param;
    const { colors, borderRadius } = (0, _Theme.useTheme)();
    const { inGroup } = (0, _react.useContext)(_FormInputGroupContext.FormInputGroupContext);
    const { labelId, hintId } = (0, _react.useContext)(_FormGroupContext.FormGroupContext);
    const showBorder = noBorder !== true && !inGroup;
    return /*#__PURE__*/ _react.default.createElement("ul", {
        "aria-labelledby": labelId,
        "aria-describedby": hintId,
        ...props,
        ref: ref,
        className: _style.default.dynamic([
            [
                "c04157c5e59d70d8",
                [
                    variant === "light" ? colors.light : colors.white,
                    borderRadius,
                    !showBorder ? "none" : "1px solid ".concat(colors.border),
                    maxHeight != null ? maxHeight : "none",
                    maxHeight != null ? "auto" : "visible",
                    inGroup ? "100%" : "auto"
                ]
            ]
        ]) + " " + (props && props.className != null && props.className || "")
    }, children, /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "c04157c5e59d70d8",
        dynamic: [
            variant === "light" ? colors.light : colors.white,
            borderRadius,
            !showBorder ? "none" : "1px solid ".concat(colors.border),
            maxHeight != null ? maxHeight : "none",
            maxHeight != null ? "auto" : "visible",
            inGroup ? "100%" : "auto"
        ]
    }, "ul.__jsx-style-dynamic-selector{background:".concat(variant === "light" ? colors.light : colors.white, ";list-style-type:none;margin:0;padding:0;-webkit-border-radius:").concat(borderRadius, ";-moz-border-radius:").concat(borderRadius, ";border-radius:").concat(borderRadius, ";border:").concat(!showBorder ? "none" : "1px solid ".concat(colors.border), ";max-height:").concat(maxHeight != null ? maxHeight : "none", ";overflow:").concat(maxHeight != null ? "auto" : "visible", ";width:").concat(inGroup ? "100%" : "auto", "}")));
});
ListGroup.displayName = "ListGroup";

//# sourceMappingURL=ListGroup.js.map